import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { CheckCircle2, XCircle, Clock, Calendar, TrendingUp } from 'lucide-react';
export const DetailsSection = () => {
  const forWho = ['Mujeres de 50+ años que se sienten agotadas crónicamente.', "Mujeres que sufren de 'neblina mental' y falta de concentración.", 'Quienes buscan una solución práctica y directa, sin teorías complicadas.', 'Mujeres que quieren recuperar su vitalidad para disfrutar su vida activa.'];
  const notForWho = ['Personas que buscan una solución médica o farmacológica inmediata.', 'Quienes no están dispuestas a cambiar su café en ayunas por 5 minutos de luz solar.', 'Hombres o mujeres jóvenes con realidades hormonales distintas.'];
  const steps = [{
    icon: <Clock className="w-6 h-6 text-gold" data-id="element-11" />,
    title: 'Paso 1: Descarga y Evalúa',
    desc: 'Descarga el plan y realiza tu Auditoría de Energía de 2 minutos.'
  }, {
    icon: <Calendar className="w-6 h-6 text-gold" data-id="element-12" />,
    title: 'Paso 2: Micro-Ajustes',
    desc: 'Implementa los micro-ajustes semanales (Semana 1: Luz, Semana 2: Comida, Semana 3: Sueño).'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-gold" data-id="element-13" />,
    title: 'Paso 3: Estabiliza',
    desc: 'Sigue los checklists diarios y observa cómo tu energía se estabiliza en 21 días.'
  }];
  return <>
      <Section bg="bg-cream-light" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-15">
          <FadeIn data-id="element-16">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-sage" data-id="element-17">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-18">
                <CheckCircle2 className="w-8 h-8 text-sage" data-id="element-19" />
                Para quién es esto
              </h3>
              <ul className="space-y-5" data-id="element-20">
                {forWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-21">
                    <div className="mt-1.5 w-2 h-2 rounded-full bg-sage shrink-0" data-id="element-22" />
                    <span className="text-brown-light" data-id="element-23">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-24">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-coral/50" data-id="element-25">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-26">
                <XCircle className="w-8 h-8 text-coral/70" data-id="element-27" />
                Para quién NO es
              </h3>
              <ul className="space-y-5" data-id="element-28">
                {notForWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-29">
                    <div className="mt-1.5 w-2 h-2 rounded-full bg-coral/50 shrink-0" data-id="element-30" />
                    <span className="text-brown-light" data-id="element-31">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </Section>

      <Section bg="bg-cream-dark/20" data-id="element-32">
        <FadeIn data-id="element-33">
          <div className="text-center mb-16" data-id="element-34">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-35">
              Cómo funciona
            </h2>
            <p className="text-brown-light" data-id="element-36">
              Un proceso simple, diseñado para mujeres ocupadas.
            </p>
          </div>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-3 gap-8 relative" data-id="element-37">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gold-light -z-10" data-id="element-38"></div>

          {steps.map((step, index) => <StaggerItem key={index} data-id="element-39">
              <div className="text-center relative" data-id="element-40">
                <div className="w-24 h-24 mx-auto bg-white rounded-full flex items-center justify-center shadow-md border-4 border-cream-light mb-6" data-id="element-41">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-42">{step.title}</h3>
                <p className="text-brown-light px-4" data-id="element-43">{step.desc}</p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </Section>

      <Section bg="bg-gold/10" data-id="element-44">
        <FadeIn data-id="element-45">
          <div className="max-w-3xl mx-auto text-center" data-id="element-46">
            <span className="text-gold font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-47">
              Lo que cambia en 7 días
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-48">
              Notarás que la pesadez mental al despertar desaparece.
            </h2>
            <p className="text-lg md:text-xl text-brown-light leading-relaxed bg-white p-8 rounded-2xl shadow-sm" data-id="element-49">
              Al ajustar el orden de tus alimentos y la exposición a la luz, tu
              cuerpo deja de luchar contra sí mismo y comienza a producir
              energía estable desde la primera hora del día.
            </p>
          </div>
        </FadeIn>
      </Section>
    </>;
};